import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { z } from "zod";
import { supabase } from "@/lib/supabase";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "@/hooks/use-toast";

const schema = z.object({ email: z.string().trim().email("Email inválido").max(255) });

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  // Força Light Mode na Landing Page
  useEffect(() => {
    const root = document.documentElement;
    const hadDark = root.classList.contains("dark");
    if (hadDark) {
      root.classList.remove("dark");
      root.classList.add("light");
    }
    return () => {
      if (hadDark) {
        root.classList.remove("light");
        root.classList.add("dark");
      }
    };
  }, []);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const parsed = schema.safeParse({ email });
    if (!parsed.success) {
      toast({ title: "Email inválido", variant: "destructive" });
      return;
    }
    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(parsed.data.email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    setLoading(false);
    // Resposta genérica por segurança
    toast({ title: "Verifique seu email", description: "Se a conta existir, enviamos um link de redefinição." });
    if (error) console.error(error);
  }

  return (
    <div className="min-h-screen grid place-items-center bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-blue-50/50 via-white to-blue-50/50 text-slate-900 font-sans p-4 relative overflow-hidden">
      <Card className="w-full max-w-md p-8 space-y-6">
        <div>
          <h1 className="text-xl font-semibold">Redefinir senha</h1>
          <p className="text-xs text-muted-foreground">Enviaremos um link para seu email</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <Button type="submit" className="w-full" disabled={loading}>{loading ? "Enviando..." : "Enviar link"}</Button>
        </form>
        <p className="text-center text-sm">
          <Link to="/login" className="text-primary hover:underline">Voltar ao login</Link>
        </p>
      </Card>
    </div>
  );
}
